import { useContext } from "react";
import { format as dateFnsFormat } from "date-fns";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../store/ui-context";

export const useAPIGetVacation = () => {
  const uiContext = useContext(UiContext);
  const { requestGet } = useAPIRequest();

  const fetchVacationsByDate = (date) => {
    // If date is already a string, use it directly; otherwise format it
    const dateString = typeof date === 'string' ? date : dateFnsFormat(date ?? new Date(), "yyyy-MM-dd");

    return new Promise((resolve) => {
      requestGet({
        fullUrl: `/api/masterdata/employeevacation/data`,
        params: {
          page: 1,
          take: 3000,
          filter: `date:>=:${dateString};date:<=:${dateString}`,
          order: "date",
          order_method: "ASC",
          with_employee: 1,
        },
        onSuccess: ({ data }) => {
          resolve(data || []);
        },
        onError: ({ message }) => {
          console.error("Error fetching vacation data:", message);
          resolve([]);
        },
      });
    });
  };

  // Build a map of employee_id -> vacation status for quick lookup
  const buildVacationMap = (vacationData) => {
    const vacationMap = {};

    if (Array.isArray(vacationData)) {
      vacationData.forEach((vacation) => {
        if (vacation.employee_id) {
          vacationMap[vacation.employee_id] = vacation;
        }
      });
    }

    return vacationMap;
  };

  // Check if employee is on vacation
  const isEmployeeOnVacation = (employeeId, vacationMap) => {
    return vacationMap.hasOwnProperty(employeeId);
  };

  // Get vacation details for employee
  const getVacationDetails = (employeeId, vacationMap) => {
    return vacationMap[employeeId] || null;
  };

  return {
    fetchVacationsByDate,
    buildVacationMap,
    isEmployeeOnVacation,
    getVacationDetails,
  };
};
